export const numberWithCommas = (x, toFixed) => {
  let floatValue = isNaN(parseFloat(x)) ? 0 : parseFloat(x);
  if (toFixed) floatValue = floatValue.toFixed(2);
  return floatValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getLoadTypeFromDescription = (desc = '') => {
  if (/file\s*upload/i.test(desc) || desc.includes('FileUpload')) {
    return 'Import Your Load';
  }

  if (/cm8/i.test(desc)) {
    return 'CM8';
  }

  if (/BuildYourLoad/i.test(desc)) {
    return 'Build Your Load';
  }

  return desc; // e.g. 'Build Your Load', 'Customer Submission', or duplicated load TransferID
};

/**
 * Build FormData from various submit inputs (FormData, form element, or plain object).
 * @param {FormData | HTMLFormElement | Record<string, any>} submit
 * @returns {FormData}
 */
export const buildPortsFormData = (submit) => {
  if (submit instanceof FormData) return submit;
  if (submit?.tagName === 'FORM') return new FormData(submit);
  if (typeof submit === 'object') {
    const fd = new FormData();
    Object.entries(submit).forEach(([k, v]) => fd.append(k, v ?? ''));
    return fd;
  }
  return new FormData();
};
